import { useState, useEffect } from "react";
import { AxiosError } from "axios";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Table from "../../../core/common/dataTable/index";
import { EvaluationPeriodTable } from "../../../core/data/interface"; //Les types des colones de notre tableau déclaré au préalable
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import EditEvaluationPeriodModal from "./editEvaluationPeriodModal";
import CreateEvaluationPeriodModal from "./CreateEvaluationPeriodModal";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import {
  deleteEvaluationPeriod,
  getAllEvaluationPeriod,
} from "../../../api/generalParam";
import InfosAlertYearDisabled from "../../../core/common/alerts/infosAlertYearDisabled";
import {
  Action,
  buildPermission,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
import withPermission from "../../../core/common/autorisations/withPermission";

// bouton protégée pour créer une période d'évaluation
const ProtectedBtnAddPeriodEval = withPermission(
  (props: any) => (
    <div className="mb-2">
      <button
        onClick={() => {
          props.setShowCreate(true);
        }}
        //   to="#"
        // disabled={!selectedYear?.statut}
        className="btn btn-primary d-flex align-items-center"
      >
        <i className="ti ti-square-rounded-plus me-2" />
        Nouvelle Période
      </button>
    </div>
  ),
  [buildPermission(Resource.EVAL_PERIOD, Action.CREATE)],
  "masquer",
);

// bouton protégée pour modifier une période d'évaluation
const ProtectedBtnUpdatePeriodEval = withPermission(
  (props: any) => (
    <li>
      <button
        className="dropdown-item rounded-1"
        // to="#"
        // disabled={!selectedYear?.statut}
        onClick={() => {
          props.setEditEvaluationPeriod(props.record.id);
          props.setShowEdit(true);
        }}
      >
        <i className="ti ti-edit-circle me-2" />
        Modifier
      </button>
    </li>
  ),
  [buildPermission(Resource.EVAL_PERIOD, Action.UPDATE)],
  "masquer",
);

// bouton protégée pour supprimer une période d'évaluation
const ProtectedBtnDeletePeriodEval = withPermission(
  (props: any) => (
    <li>
      <button
        onClick={() => props.showConfirmationAlert(props.record)}
        className="dropdown-item rounded-1"
        // to="#"
        // disabled={!selectedYear?.statut}
      >
        <i className="ti ti-trash-x me-2" />
        Supprimer
      </button>
    </li>
  ),
  [buildPermission(Resource.EVAL_PERIOD, Action.DELETE)],
  "masquer",
);

const EvaluationPeriodList = () => {
  const { selectedYear } = useAcademicYear();

  //Initialisation des state utilisés
  const [allEvaluationPeriod, setAllEvaluationPeriod] = useState([]);
  const [editEvaluationPeriod, setEditEvaluationPeriod] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données

  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const [refreshKey, setRefreshKey] = useState(0);
  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  // Les colonnes de notre tableau
  const columns = [
    {
      title: "Niveau",
      dataIndex: "Level",
      render: (level: any) => level?.label || "-", // Affiche le label ou un tiret si absent
      sorter: (a: EvaluationPeriodTable, b: EvaluationPeriodTable) => {
        const labelA = a.Level?.label || "";
        const labelB = b.Level?.label || "";
        return labelA.localeCompare(labelB);
      },
    },
    {
      title: "Libellé",
      dataIndex: "label",
      sorter: (a: EvaluationPeriodTable, b: EvaluationPeriodTable) =>
        a.label.length - b.label.length,
    },
    {
      title: "Abréviation",
      dataIndex: "abbreviation",
      sorter: (a: EvaluationPeriodTable, b: EvaluationPeriodTable) =>
        a.abbreviation.length - b.abbreviation.length,
    },
    {
      title: "Début",
      dataIndex: "startDate",
      render: (date: string) => {
        const d = new Date(date);
        return d.toLocaleDateString("fr-FR", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      },
      sorter: (a: EvaluationPeriodTable, b: EvaluationPeriodTable) =>
        new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
    },
    {
      title: "Fin",
      dataIndex: "endDate",
      render: (date: string) => {
        const d = new Date(date);
        return d.toLocaleDateString("fr-FR", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      },
      sorter: (a: EvaluationPeriodTable, b: EvaluationPeriodTable) =>
        new Date(a.endDate).getTime() - new Date(b.endDate).getTime(),
    },
    {
      title: "Date de création",
      dataIndex: "createdAt",
      render: (date: string) => {
        const d = new Date(date);
        return d.toLocaleDateString("fr-FR", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      },
      sorter: (a: EvaluationPeriodTable, b: EvaluationPeriodTable) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <ProtectedBtnUpdatePeriodEval
                  setEditEvaluationPeriod={setEditEvaluationPeriod}
                  record={record}
                  setShowEdit={setShowEdit}
                />

                <ProtectedBtnDeletePeriodEval
                  showConfirmationAlert={showConfirmationAlert}
                  record={record}
                />
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];

  //Traitement en alert de la demande de suppression de salle de classe
  const showConfirmationAlert = (evaluationPeriod: any) => {
    MySwal.fire({
      title: "Supprimer une période ?",
      text: `Souhaitez-vous vraiment supprimer la période ${evaluationPeriod.label} ?`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête d'envoi de mail
          await deleteEvaluationPeriod(evaluationPeriod?.id);
          MySwal.fire({
            title: "Période supprimée avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });

          reloadData(); //On reload la liste
        } catch (error) {
          const err = error as AxiosError<any>;
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: err.response?.data?.message || err.response?.data?.error,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  //Reload de la liste
  const reloadData = () => setRefreshKey((prev) => prev + 1);

  //On recupère la liste des Salles de classe en appelant sa fonction
  useEffect(() => {
    const fetchData = async () => {
      // On attend que selectedYear soit défini
      if (!selectedYear?.id) return;

      setHasLoaded(false);
      setIsLoading(true);

      try {
        const evaluationPeriods = await getAllEvaluationPeriod(
          selectedYear?.id,
        );
        // console.log(evaluationPeriods);
        setAllEvaluationPeriod(evaluationPeriods.data);
      } catch (error: any) {
        // Si erreur (Toast Error)
        // console.log(error);
        toast.error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Une erreur s'est produit, Réessayer plus tard",
      );
      } finally {
        setIsLoading(false); //Les données ne sont plus en chargement
        setHasLoaded(true); //Les données ont été chargé avec succès
      }
    };

    fetchData();
  }, [refreshKey, selectedYear]);

  return (
    <>
      {/* <div className="page-wrapper"> */}
      {/* <div className="content"> */}
      <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
        {/* Boutton en entête de la page */}
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
          {/* <TooltipOption/> */}
          <ProtectedBtnAddPeriodEval setShowCreate={setShowCreate} />
        </div>
      </div>
      {/* /Page Header */}
      {!selectedYear?.statut && <InfosAlertYearDisabled />}
      {/* Tableau liste du personnel administratif */}
      <div className="card">
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
          <h4 className="mb-3">Liste des Périodes</h4>
        </div>
        <div className="card-body p-0 py-3">
          {/* Staffs List (On affiche le tableau qui si les données son chargées même vide) */}
          {isLoading && !hasLoaded ? (
            <div className="text-center">
              <div className="spinner-border" role="status"></div>
              <span className="visually">Chargement des Données...</span>
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={allEvaluationPeriod}
              Selection={true}
            />
          )}
          {/* /Staffs List */}
        </div>
      </div>
      {/* /Page Header */}

      <EditEvaluationPeriodModal
        show={showEdit}
        periodID={editEvaluationPeriod}
        onClose={() => setShowEdit(false)}
        onSaved={reloadData}
      />
      <CreateEvaluationPeriodModal
        show={showCreate}
        onClose={() => setShowCreate(false)}
        onSaved={reloadData}
      />
    </>
  );
};

export default EvaluationPeriodList;
